// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_quill_dist_quill_js":"740e06dfe717c629","node_modules_profabric_web-components_dist_esm_pf-button_6_entry_js":"35d6bdf843534861"}[chunkId] + ".js";
};